import styled from 'styled-components';

import { BaseContainer } from './BaseContainer';

interface IProps {
    isOpenVirtualKeyboard?: boolean;
    isInstruction?: boolean;
}

export const FullHeightContainer = styled(BaseContainer)<IProps>`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 0px;
`;
